export default __webpack_public_path__ + "static/media/night_agent1.690d99a6.jpg";